import resourceList from '../resource_list';
import rest from '../rest';

async function saveEmailUnsubscribeOptions(ref, preferences) {
  return rest.post(resourceList.AUTH, '/email/save-unsubscribe-preferences', {ref, preferences,});
}

export default saveEmailUnsubscribeOptions;
